<template>
  <div id='firebaseui-auth-container'></div>
</template>

<script>
import * as firebaseui from 'firebaseui'
/* purgecss start ignore */
import 'firebaseui/dist/firebaseui.css'
/* purgecss end ignore */

export default {
  name: "Auth",
  mounted() {
      // FirebaseUI config.
      const uiConfig = {
        signInSuccessUrl: '/',
        signInOptions: [
          {
            provider: this.$firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false,
          }
        ],
        // tosUrl and privacyPolicyUrl accept either url string or a callback
        // function.
        // Terms of service url/callback.
        tosUrl: '<your-tos-url>',
        // Privacy policy url/callback.
        privacyPolicyUrl: function() {
          window.location.assign('<your-privacy-policy-url>');
        }
      };

      // Initialize the FirebaseUI Widget using Firebase.
      const ui = new firebaseui.auth.AuthUI(this.$auth);
      // The start method will wait until the DOM is loaded.
      ui.start('#firebaseui-auth-container', uiConfig);
  },
}
</script>